import GiftCards from "./giftcards";
import { Messaging } from "./messaging";
export default class API {
    static giftCards = GiftCards;
    static messaging = Messaging;
}
